import {ForYouModalStep} from "../types/ForYouModalStep";

export const modalStepsDescriptions: {[key: number]: {title: string; desc: string}} = {
    [ForYouModalStep.REGION]: {
        title: "Wybierz lokalizację",
        desc: "Wybierz miejsce, gdzie chcesz mieszkać. Mieszkania w wybranej przez Ciebie dzielnicy będą traktowane priorytetowo."
    },
    [ForYouModalStep.CRITERIA]: {
        title: "Określ kryteria mieszkaniowe",
        desc: "Określ podstawowe parametry Twojego mieszkania. W przypadku budżetu możesz posłużyć się kwotą całkowitą lub maksymalną ratą kredytu, jaką jesteś gotowy płacić."
    },
    [ForYouModalStep.USER]: {
        title: "Podaj swoje dane kontaktowe",
        desc: "Twoje dane są niezbędne, abyśmy mogli się z Tobą skontaktować w celu przedstawienia interesujących ofert."
    },
    [ForYouModalStep.ADDITIONAL]: {
        title: "Dodatkowe kryteria",
        desc: "Dziękujemy za zgłoszenie. Jeśli są jakieś szczególne cechy na które powinnam zwrócić uwagę, poniżej możesz doprecyzować swoje kryteria."
    }
};
import {ForYouModalStep} from "../types/ForYouModalStep";

export const modalStepsDescriptions: {[key: number]: {title: string; desc: string}} = {
    [ForYouModalStep.REGION]: {
        title: "Wybierz lokalizację",
        desc: "Wybierz miejsce, gdzie chcesz mieszkać. Mieszkania w wybranej przez Ciebie dzielnicy będą traktowane priorytetowo."
    },
    [ForYouModalStep.CRITERIA]: {
        title: "Określ kryteria mieszkaniowe",
        desc: "Określ podstawowe parametry Twojego mieszkania. W przypadku budżetu możesz posłużyć się kwotą całkowitą lub maksymalną ratą kredytu, jaką jesteś gotowy płacić."
    },
    [ForYouModalStep.USER]: {
        title: "Podaj swoje dane kontaktowe",
        desc: "Twoje dane są niezbędne, abyśmy mogli się z Tobą skontaktować w celu przedstawienia interesujących ofert."
    },
    [ForYouModalStep.ADDITIONAL]: {
        title: "Dodatkowe kryteria",
        desc: "Dziękujemy za zgłoszenie. Jeśli są jakieś szczególne cechy na które powinnam zwrócić uwagę, poniżej możesz doprecyzować swoje kryteria."
    }
};
